import React from 'react';

const ProtectedPage: React.FC = () => (
  <div>
    <h1>Hi from the ProtectedPage</h1>
  </div>
);

export default ProtectedPage;
